import React, { useContext } from 'react'
import { TextField } from '@material-ui/core';
import { FormContext } from '../../../../hooks/useForm/FormContext';

export const Epidemiologicos = ({setShow}: any ) => {

    const { formValues ,handleInputChange } = useContext(FormContext);
    const { ant_epidemiologicos } = formValues;
 

    const handleVolver = () => {
        setShow({ant_main:true});
    }

    return ( 

        <div className="options animate__animated animate__fadeIn">
            <div className="titulo_seccion">
                Ant. Epidemiologicos
            </div>
            <hr />
            <button className="main_button back" onClick={handleVolver}>
                Volver
            </button>
            <div className="content">
                <div className="divInput"> 
                    <TextField 
                        id="outlined-basic" 
                        label="Epidemiologicos"
                        variant="outlined"  
                        type="text" 
                        multiline 
                        fullWidth 
                        rows="5" 
                        color="secondary"
                        onChange={handleInputChange}
                        name="ant_epidemiologicos"
                        value={ant_epidemiologicos}
                    />
                </div> 
            </div>
        </div> 
    )
}
